import { closePopup, openPopup } from '@/popups';

export class RegisterForm {
  $codeTimer;
  $popupTimer;
  $popupWaitTimer;
  $lectorCheckbox;
  $lectorBlock;
  $lectorBlockCheckbox;

  timer;
  init() {
    this.$popupWaitTimer = $('#popup-wait-timer');
    this.$lectorCheckbox = $('.lector-checkbox');
    this.$lectorBlock = $('.lector-block');
    this.$lectorBlockCheckbox = $('.lector-block-checkbox');

    this.initEvents();
    this.initTimerPhoneCode();
    this.initProfessionsSelect();
    this.initEditControl();
    this.validPasswordInit();
    this.initResetPassword();
  }

  initEditControl() {
    $('.edit-control').on('click', (e) => {
      $(e.currentTarget)
        .parents('.form-field')
        .find('.form-control, .form-control-select')
        .attr('disabled', false);
    });
  }

  initTimerPhoneCode() {
    this.$codeTimer = $('.code-timer');
    this.$popupTimer = $('.popup-timer');
    if (this.$codeTimer && this.$codeTimer.length > 0) {
      const time = 2 * 60 + 43; //2:43
      this.startTimer(time);
    }
  }

  startTimer(duration) {
    let minutes;
    let seconds;
    this.timer = duration;
    const interval = setInterval(() => {
      minutes = parseInt(this.timer / 60, 10);
      seconds = parseInt(this.timer % 60, 10);

      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      this.$codeTimer.text(minutes + ':' + seconds);
      this.$popupTimer.text(minutes + ':' + seconds);

      if (--this.timer < 0) {
        this.$codeTimer.text('');
        if (this.$popupWaitTimer.is('.popup-show')) {
          closePopup(this.$popupWaitTimer);
        }
        clearInterval(interval);
      }
    }, 1000);
  }

  initEvents() {
    $('.register-step-1').on('click', (e) => {
      //todo actions
    });

    $('.register-accept-phone').on('click', (e) => {
      //todo actions
    });

    $('.resend-phone-code').on('click', (e) => {
      if (--this.timer >= 0) {
        openPopup($('#popup-wait-timer'));
      } else {
        //todo actions
      }
    });

    $('.register-step-2').on('click', (e) => {
      e.preventDefault();
      if (this.$lectorCheckbox.prop('checked')) {
        openPopup($('#popup-lector'));
      } else {
        //todo actions
      }
    });

    this.$lectorCheckbox.on('change', (e) => {
      if (this.$lectorCheckbox.prop('checked')) {
        this.$lectorBlock.show();
      } else {
        this.$lectorBlock.hide();
      }
    });
  }

  initProfessionsSelect() {
    const $professionsSelect = $('.form-control-select-professions');
    if (!$professionsSelect || $professionsSelect.length === 0) return;

    const $specializations = $('.form-field-specializations');
    const placeholder = $professionsSelect.data('placeholder');

    $professionsSelect.select2({
      selectionCssClass: ':all:',
      dropdownCssClass: ':all:',
      placeholder: placeholder,
      minimumResultsForSearch: Infinity,
    });

    $professionsSelect.on('change', (e) => {
      if ($professionsSelect.val() <= 4) {
        $specializations.addClass('show');
      } else {
        $specializations.removeClass('show');
      }
    });
  }

  /*
   * Вывод ошибки при несовпавших паролях
   * */

  validPasswordInit() {
    const $p1 = $('.password1');
    const $p2 = $('.password2');

    $p2.on('blur', () => {
      if ($p1.val() !== $p2.val()) {
        $p2.addClass('error');
      } else {
        $p2.removeClass('error');
      }
    });
  }

  initResetPassword() {
    $('.button-reset-password').on('click', (e) => {
      e.preventDefault();
      const $control = $('.registration-tabs-pane.active .form-control');
      const value = $control.val();
      if (value && !$control.is('.error')) {
        $control.removeClass('error error-required');
        $control.prev('.select2').removeClass('error');
        //todo actions
        openPopup($('#popup-password-send'));
      }
      if (value && $control.is('.error')) {
        $control.removeClass('error-required');
      }
      if (!value) {
        $control.addClass('error error-required');
        $control.prev('.select2').addClass('error');
      }
    });

    $('.button-resend-password').on('click', (e) => {
      e.preventDefault();
      //todo actions
    });

    $('.button-change-password').on('click', (e) => {
      e.preventDefault();
      //todo action
      openPopup($('#popup-password-change-success'));
    });
  }
}
